import { render } from "./PreOrder.vue?vue&type=template&id=87ba7f44&scoped=true"
import script from "./PreOrder.vue?vue&type=script&lang=js"
export * from "./PreOrder.vue?vue&type=script&lang=js"

import "./PreOrder.vue?vue&type=style&index=0&id=87ba7f44&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ba7f44"]])

export default __exports__